import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_SEASON_PASSES,
  GET_SEASON_PASS_DETAIL,
  ADD_NEW_SEASON_PASS,
  UPDATE_SEASON_PASS,
  DELETE_SEASON_PASS,
} from "./actionTypes"
import {
  getSeasonPassesSuccess,
  getSeasonPassFail,
  getSeasonPassDetailSuccess,
  getSeasonPassDetailFail,
  addSeasonPassFail,
  addSeasonPassSuccess,
  updateSeasonPassSuccess,
  updateSeasonPassFail,
  deleteSeasonPassSuccess,
  deleteSeasonPassFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getSeasonPasses,
  getSeasonPassDetails,
  addNewSeasonPass,
  updateSeasonPass,
  deleteSeasonPass,
} from "helpers/backend_helper"

function* fetchSeasonPasses({ payload }) {
  try {
    const response = yield call(getSeasonPasses, payload)
    yield put(getSeasonPassesSuccess(response))
  } catch (error) {
    yield put(getSeasonPassFail(error))
  }
}

function* fetchSeasonPassDetail({ SeasonPassId }) {
  try {
    const response = yield call(getSeasonPassDetails, SeasonPassId)
    yield put(getSeasonPassDetailSuccess(response))
  } catch (error) {
    yield put(getSeasonPassDetailFail(error))
  }
}

function* onUpdateSeasonPass({ payload: SeasonPass }) {
  try {
    const response = yield call(updateSeasonPass, SeasonPass)
    if (response?.success) {
      yield put(updateSeasonPassSuccess(response))
    } else {
      yield put(updateSeasonPassFail(response?.message))
    }
  } catch (error) {
    yield put(updateSeasonPassFail(error))
  }
}

function* onAddNewSeasonPass({ payload: SeasonPass }) {
  try {
    const response = yield call(addNewSeasonPass, SeasonPass)
    if (response?.success) {
      yield put(addSeasonPassSuccess(response))
    } else {
      yield put(addSeasonPassFail(response))
    }
  } catch (error) {
    yield put(addSeasonPassFail(error))
  }
}

function* onDeleteSeasonPass({ payload: SeasonPass }) {
  try {
    const response = yield call(deleteSeasonPass, SeasonPass)
    if (response?.success) {
      yield put(deleteSeasonPassSuccess(SeasonPass))
    } else {
      yield put(deleteSeasonPassFail(response?.message))
    }
  } catch (error) {
    yield put(deleteSeasonPassFail(error))
  }
}

function* seasonPassSaga() {
  yield takeEvery(GET_SEASON_PASSES, fetchSeasonPasses)
  yield takeEvery(GET_SEASON_PASS_DETAIL, fetchSeasonPassDetail)
  yield takeEvery(ADD_NEW_SEASON_PASS, onAddNewSeasonPass)
  yield takeEvery(UPDATE_SEASON_PASS, onUpdateSeasonPass)
  yield takeEvery(DELETE_SEASON_PASS, onDeleteSeasonPass)
}

export default seasonPassSaga
